<div *ngIf="message" class="message" [class.left]="messageSide === 'left'">
  <div class="profile-picture" *ngIf="messageSide === 'left' && message.sentBy !== null">
    <p class="initials">{{ message.sentBy.firstName.substr(0, 1) }}</p>
  </div>
  <div class="message-details">
    <p class="message-info" *ngIf="message.sentBy !== null">
      <span *ngIf="messageSide !== 'left'">{{message.sentBy.firstName}} • </span>
      {{message.created | dateToString:'message'}}
      <span *ngIf="messageSide === 'left'"> • {{message.sentBy.firstName}}</span>
    </p>
    <div class="message-content">
      <span class="triangle"></span>
      <p class="message-text" [innerHTML]="message.message"></p>
    </div>
  </div>
  <div class="profile-picture" *ngIf="messageSide === 'right' && message.sentBy !== null">
    <p class="initials">{{ message.sentBy.firstName.substr(0, 1) }}</p>
  </div>
</div>
